'use client';
import { jsx } from 'react/jsx-runtime';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

/**
 * Input renders a native `input` element.
 *
 * @example
 * <Input />
 */
const Input = forwardRef(function Input({ type = 'text', className, onChange, onClick, ...rest }, ref) {
    return (jsx("input", { className: cl(`ds-input`, className), ref: ref, type: type, suppressHydrationWarning // Since <ds-field> adds attributes
        : true, onChange: (event) => rest.readOnly || onChange?.(event), onClick: (event) => {
            if (rest.readOnly)
                event.preventDefault(); // Make readonly work for checkbox / radio / switch
            onClick?.(event);
        }, ...rest }));
});

export { Input };
